import { render, staticRenderFns } from "./results-new.vue?vue&type=template&id=deef7328&scoped=true"
import script from "./results-new.vue?vue&type=script&lang=js"
export * from "./results-new.vue?vue&type=script&lang=js"
import style0 from "./results-new.vue?vue&type=style&index=0&id=deef7328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deef7328",
  null
  
)

export default component.exports